import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["audio", "progress", "elapsed", "duration", "icon", "downloadButton", "errorDisplay"]
  static values = { trackUrl: String, trackToken: String }

  connect() {
    this.playTracked = false
    if (!this.hasAudioTarget) return

    this.audioTarget.addEventListener("timeupdate", () => this.updateProgress())
    this.audioTarget.addEventListener("loadedmetadata", () => this.updateDuration())
    this.audioTarget.addEventListener("ended", () => this.resetIcon())
    this.updateDuration()
  }

  toggle() {
    if (this.audioTarget.paused) {
      this.audioTarget.play()
      this.trackOnce("played")
      this.iconTarget.innerHTML = '<rect x="16" y="14" width="5" height="20" rx="2" fill="#FFFFFF"></rect><rect x="27" y="14" width="5" height="20" rx="2" fill="#FFFFFF"></rect>'
    } else {
      this.audioTarget.pause()
      this.resetIcon()
    }
  }

  download(event) {
    event.preventDefault()
    this.track("downloaded")

    const button = event.currentTarget
    const url = button.getAttribute("data-download-audio")
    const filename = button.getAttribute("data-download-filename")
    if (!url || !filename) return

    if (window.Telegram?.WebApp?.downloadFile) {
      this.setDownloadBusy(true)
      window.Telegram.WebApp.downloadFile({ url: url, file_name: filename }, (accepted) => {
        this.setDownloadBusy(false)
        if (!accepted) return

        if (window.Telegram?.WebApp?.MainButton) {
          Telegram.WebApp.MainButton.setText("Close")
          Telegram.WebApp.MainButton.onClick(() => Telegram.WebApp.close())
          Telegram.WebApp.MainButton.show()
        } else if (window.Telegram?.WebApp?.close) {
          Telegram.WebApp.close()
        }
      })
      return
    }

    window.open(url, "_blank", "noopener")
  }

  generateAnother() {
    this.track("generate_another_clicked")
  }

  updateProgress() {
    const duration = this.audioTarget.duration || 0
    const current = this.audioTarget.currentTime || 0
    const ratio = duration > 0 ? (current / duration) * 100 : 0
    this.progressTarget.style.width = `${ratio}%`
    this.elapsedTarget.textContent = this.formatTime(current)
  }

  updateDuration() {
    const duration = this.audioTarget.duration || 0
    this.durationTarget.textContent = this.formatTime(duration)
  }

  resetIcon() {
    this.iconTarget.innerHTML = '<polygon points="20 14 36 24 20 34" fill="#FFFFFF"></polygon>'
  }

  formatTime(value) {
    const totalSeconds = Math.floor(value)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = String(totalSeconds % 60).padStart(2, "0")
    return `${minutes}:${seconds}`
  }

  trackOnce(eventName, properties = {}) {
    if (eventName === "played" && this.playTracked) return

    this.track(eventName, properties)
    if (eventName === "played") this.playTracked = true
  }

  track(eventName, properties = {}) {
    if (!this.hasTrackUrlValue) return

    const formData = new FormData()
    formData.append("event", eventName)
    if (this.hasTrackTokenValue) formData.append("token", this.trackTokenValue)
    Object.entries(properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value))

    if (navigator.sendBeacon) {
      navigator.sendBeacon(this.trackUrlValue, formData)
      return
    }

    fetch(this.trackUrlValue, {
      method: "POST",
      body: formData,
      keepalive: true,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    }).catch(() => {})
  }

  setDownloadBusy(isBusy) {
    if (!this.hasDownloadButtonTarget) return

    this.downloadButtonTarget.disabled = isBusy
    this.downloadButtonTarget.setAttribute("aria-disabled", isBusy ? "true" : "false")
  }
}
